/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { CATEGORY_REVENUE_PERCENTAGE_FRAGMENT } from '../fragments'

export const GET_PRODUCT_CATEGORY_REVENUE_PERCENTAGE = gql`
  query ProductCategoryRevenuePercentage(
    $filters: CategoryRevenuePercentageFilter!
  ) {
    categoryRevenuePercentage(filters: $filters) {
      ...CategoryRevenuePercentage
    }
  }
  ${CATEGORY_REVENUE_PERCENTAGE_FRAGMENT}
`
